<template>
  <v-container mt-0 fluid>
    <v-layout align-space-around fill-height  row>
      <v-flex xs6>
        <v-layout>
          <v-flex xs6 pl-2 pt-0 mt-0>
            <swatches  v-model="color" style="display: inline-block;top: 16px;"/>
            <v-text-field v-model="playlistName" style="display: inline-block;padding-top:0px;margin-top:0px;width:70%">New Playlist</v-text-field>
          </v-flex>
          <v-flex xs6 pl-2 pr-4 pt-0 mt-0>
            <v-combobox 
              v-if="playlists"
              v-model="loadedList"
              :items="playlists"
              item-text="name"
              label="Load Existing Playlist"
              return-object
              hide-selected>
            </v-combobox>
          </v-flex>
        </v-layout>
        <v-container id="scroll-target" style="height: 75vh" class="scroll-y">
     <v-layout>
      <v-flex sm12>
        <draggable style="position:relative;" id="mainList" v-model="playlist" :options="{group:'people'}"    @change="onChange" >
          <transition-group style="background-color:#eee;min-height:70vh;display:block" >
            <v-card v-for="(element,ei) in playlist" :key="element.tid+'_'+ei" :id="element.tid"  :min-height="mediaHeight(element)" :color="element.color" >
                <v-container @click="currentElement=element" fluid grid-list-sm >
                  <v-layout row wrap>
                    <v-flex xs4>
                      <v-card-media v-if="element.type!='title'">
                        <video v-if="false"
                            :src="element.videoUrl"
                            height="110px" :poster="element.imageUrl"
                        ></video>
                        <img  v-if="element.imageUrl" @click="showDetails(element)" :src="element.imageUrl" height="110">
                
                      </v-card-media>
                      <div v-if="element.type=='title'" class="titlePreview">
                        <div class=pTitle>{{element.title}}</div>
                        <div class=pSubtitle>{{element.subtitle}}</div>
                        <div class=pBody>{{element.body}}</div>
                        <div class=pFooter>{{element.footer}}</div>
                      </div>
                    </v-flex>
                    <v-flex xs7>
                      <v-card-text>
                        <h4>{{element.title}}</h4>
                        <span v-if="element.type=='video'">Clip length: {{secToTime(element.duration)}}<br></span>
                        <span v-if="element.type=='web'">URL: {{element.web}}<br></span>
                          {{element.type}}
                          Total duration: {{totalClipDuration(element)}}
                      </v-card-text>
                    </v-flex>
                    <v-flex xs1>
                      <v-btn @click="editdialog=true" flat fab absolute right icon small color="indigo" style="right:50px">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn  @click="removeMedia(element.tid)" flat fab absolute right icon small color="red">
                        <v-icon>delete</v-icon>
                      </v-btn><br><br>
           
                      <v-text-field v-if="element.type=='video'"  
                        label="loops"
                        value=1
                        v-model="element.loops"
                        type="number"
                        @click="textChange()"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
            </v-card>
        </transition-group>
     </draggable>
     
</v-flex>

</v-layout>
</v-container>
  <v-flex>
    <v-footer style="position:relative;bottom:0px;" slot="footer" >
      <v-layout row>
        <v-flex sm12>
          <span><b>Duration {{this.secToTime(totalDuration)}}</b></span>
         
          <v-btn style="float:right;" @click="savePlaylist">Save</v-btn>
          <v-btn v-if="loadedList" style="float:right;" @click="updatePlaylist()">Update</v-btn>
           <v-btn style="float:right;" @click="clearPlaylist">Clear</v-btn>
           
        </v-flex>
      </v-layout>
    </v-footer>
  </v-flex>
</v-flex>
<v-flex xs6 >
<v-layout row>
  <v-flex xs6>
    <v-btn v-bind:class="{ 'v-btn--active': mediaMode=='playlist' }" @click="mediaMode='playlist'">Playlists</v-btn>
    <v-btn v-bind:class="{ 'v-btn--active': mediaMode=='media' }" @click="mediaMode='media'">Media</v-btn>
  </v-flex>
  <v-flex xs6 pr-4>
        <v-combobox
          v-model="keywordList"
          :items="keywords"
          label="Search by Keywords - select from list or add your own."
          multiple
          hide-selected
          deletable-chips
          chips
        ></v-combobox>
        </v-flex>
        </v-layout>
<v-container id="scroll-target2" class="scroll-y" style="max-height: 75vh;">
  <v-layout >
    <v-flex sm12 v-if="mediaMode=='playlist'">
      <v-card  v-for="element in playlists" :key="element.id"   >
        <v-container  fluid pt-2 mb-2 :style="'background-color:'+element.color+';'">
          <v-layout row wrap>
            <v-flex xs12 style="color:#fff;margin-bottom:10px;">
              {{element.name}} {{secToTime(element.duration)}} {{element.color}}
              <v-btn @click="editPlaylist(element)" flat fab absolute right icon small color="#eee" style="right:50px;top: 0px;">
                <v-icon>add</v-icon>
              </v-btn>
              <v-btn @click="loadedList=element" flat fab absolute right icon small color="#eee" style="right:80px;top: 0px;">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn  @click="deletePlaylist(element.id)" flat fab absolute right icon small color="#eee" style="top: 0px;">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-flex>
            <v-layout style="overflow-x:auto" >
              <img v-for="(item,i) in element.items" :key="'itm'+i" ma-1 style="width:120px;height:90px;background-color:#333;"
                :src="getContent(item.id).imageUrl "> 
              
            </v-layout>   
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
    <v-flex sm12 v-if="mediaMode=='media'">
      <draggable v-model="mediaList" :options="{group:{ name:'people',  pull:'clone', put:false }}" :move="checkMove"  :clone="clone">
        <transition-group >
          <v-card v-for="element in mediaList" :key="element.id" :height="mediaHeight(element)" :color="element.color" v-if="matchesKey(element)">
            <v-container fluid grid-list-sm ma-2 pt-0>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-card-media v-if="element.type!='title'">
                    <video 
                        :src="element.videoUrl"
                        height="110px" :poster="element.imageUrl"
                    ></video>
                    
                  </v-card-media>
                  <div v-if="element.type=='title'" class="titlePreview">
                          <div class=pTitle>{{element.title}}</div>
                           <div class=pSubtitle>{{element.subtitle}}</div>
                            <div class=pBody>{{element.body}}</div>
                             <div class=pFooter>{{element.footer}}</div>
                      </div>
                </v-flex>
                <v-flex xs6>
                  <v-card-text><h4>{{element.title}}</h4>
                      <span v-if="element.artist"> {{element.artist}}<br></span>
                      <span v-if="element.type=='web'"> {{element.web}}<br></span>
                      <span v-if="element.type=='title'"> {{element.subtitle}}<br></span>

                      <span v-if="element.type=='video'"> Clip length: {{secToTime(element.duration)}}<br></span>
                       {{element.type}}
                      </v-card-text>
                      </v-flex>
                </v-layout>
                </v-container>
        </v-card>
    </transition-group> 
</draggable>

</v-flex>
</v-layout>

</v-container>
</v-flex>
</v-layout>
<v-dialog
      v-model="editdialog"
      max-width="290"
    >
      <v-card v-if="currentElement">
        <v-card-title class="headline">Edit Details</v-card-title>
        <v-card-text>
          Type:{{currentElement.type}}<br>
          <v-text-field
          v-if="editableDuration(currentElement.type)" 
          label="Duration"
          v-model="currentElement.durationText"
         
        ></v-text-field>
         <v-text-field
          v-if="currentElement.type=='video'" 
          label="Loops"
          v-model="currentElement.loops"
        >
        </v-text-field >
        <p v-if="currentElement.type=='video'">
          Duration:{{secToTime(currentElement.duration*currentElement.loops)}}
        </p >
        <p v-if="currentElement.type!='video' && !editableDuration(currentElement.type)">
          Duration:{{secToTime(currentElement.totalDuration)}}
          </p >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="green darken-1"
            flat="flat"
            @click="doEditChanges(currentElement.durationText);editdialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletedialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Delete Playlist?</v-card-title>

        <v-card-text>
         There is no going back once its gone its gone.
         Deleting playlists that are in use by a schedule will cause errors. 
         
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="deletedialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="confirmDelete()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'
import Swatches from 'vue-swatches'
export default {
  components: {
    draggable,Swatches
  },
  data () {
    return {
      deletedialog:false,
      deleteID:null,
      mediaMode:'media',
      editdialog:false,
      currentElement:null,
      color: '#1CA085',
      playlist:[
         
      ],
      loadedList:null,
      playlistName:'Playlist',
      email: '',
      password: '',
      confirmPassword: '',
      elementCount:0,
      keywordList:[],
      keywords: [
          'Animation',
          'MyState',
          'Student',
          'Stories in September',
          'TAC',
          'TAHO',
          'Tasmanian Artist',
          'The Loop',
          'Title',        
          'UTAS',
          'Visual Art',
          'Wide Angle', 
          'Test'
        ],
      
    }
  },
  created() {
      console.log("USER",this.user);
      if(this.mediaList.length==0){
        this.$store.dispatch('loadContents');
      }
  },
  mounted(){
    this.adjustTimes();
    console.log("MEDIA",this.mediaList);
  },
  
  computed: {
     playlists () {
      console.log("P",this.$store.getters.loadedPlaylists)
       return this.$store.getters.loadedPlaylists
     },
    mediaList () {
       return this.$store.getters.loadedContents
     },
    totalDuration(){
      var duration=0;
      for (var i = this.playlist.length - 1; i >= 0; --i) {
        duration+=this.playlist[i].duration*this.playlist[i].loops
      }
      return duration
    },
    getLoops () {
      return 3
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    loadedList(playlist){
        console.log(playlist);
        this.editPlaylist(playlist,true)
        
    },
    user (value) {
      console.log("HAVE A USER");
    },
   currentElement(value){
      console.log("Current Element",value);
   }
  },
  methods: {
    showDetails(content){
      console.log("ShowDetails")
      window.open(content.videoUrl, '_blank');
    },
    deletePlaylist(playlistId){
      console.log("DELETE",playlistId)
     this.deleteID = playlistId;
     this.deletedialog = true;
      //this.$store.dispatch('deletePlaylist',playlistId);   
    },
    confirmDelete(){
      console.log("DELETE -",this.deletedialog)
     this.$store.dispatch('deletePlaylist',this.deleteID); 
     this.deletedialog=false;   
    },
    cleanList(){
      this.playlist=[];
      this.loadedList=null,
      this.playlistName=="Playlist"
    },
    editPlaylist(playlist,clean){
      if(clean){
       this.playlist=[];
      }
       console.log( "playlist",playlist.items)
       var pList
       var item
       for(var i in playlist.items){
       this.elementCount++
        pList=playlist.items[i];
        item=Object.assign({}, this.getContent(pList.id))
        item.tid="clone"+this.elementCount;
        item.duration=pList.duration
        item.durationText=this.secToTime(item.duration)
        item.loops=pList.loops
         console.log("NEW",item);
         this.playlist.push(item);
        }
        if(clean || this.playlistName=="Playlist"){
        this.playlistName=playlist.name;
        this.color=playlist.color;
        }else{
          this.playlistName=this.playlistName+" + "+playlist.name;
        }
        
        //this.playlist.push(playlist.items[0]);
       // this.playlist.push(this.rebuild(this.getContent(playlist.items[0].id))
    },
    getContent(id){
      return this.$store.getters.loadedContent(id)
    },
    matchesKey(element){
     
      if(this.keywordList.length==0){
        return true;
      }
      if(this.keywordList[0]=="None" && !element.keywords){
        return true;
      }
      if(!element.keywords){
        return false;
      }
      return this.findOne(this.keywordList,element.keywords)
    },
    findOne (haystack, arr) {
            var haystack_lc= haystack.map(function(x) { return x.toLowerCase(); });
            return arr.some(function (v) {
              
                return haystack_lc.indexOf(v.toLowerCase()) >= 0;
            });
    },
    editableDuration(type){
      if(type=="URL" || type=="web" || type=="title" || type=="Camera" || type=="Blank"){
        return true
      }
      return false
    },
    doEditChanges(changes){
      console.log("doEditChanges",this.currentElement,changes)
      if(this.currentElement.type!="video"){
          this.currentElement.duration=this.timeToSec(changes);
      }
      
      
      if(this.currentElement.loops){
        this.currentElement.totalDuration= this.currentElement.duration* this.currentElement.loops
        this.currentElement.durationText=this.secToTime(this.currentElement.totalDuration)

      }else{
        this.currentElement.totalDuration=this.currentElement.duration=this.timeToSec( this.currentElement.durationText);
      }
    },
    totalClipDuration (item) {
      return this.secToTime(item.duration*item.loops)
    },
    removeMedia (id) {
      console.log("remove",id)
      for (var i = this.playlist.length - 1; i >= 0; --i) {
        if (this.playlist[i].tid == id) {
            this.playlist.splice(i,1);
        }
      }
    },
    clone (e1){
      this.elementCount++
      return {tid:"clone"+this.elementCount+"C",
                id:e1.id,
                title:e1.title,
                subtitle:e1.subtitle|| null,
                body:e1.body|| null,
                footer:e1.footer|| null,
                duration:e1.duration || 0,
                videoUrl:e1.videoUrl,
                imageUrl:e1.imageUrl,
                web:e1.web,
                color:e1.color,
                time:0,
                type:e1.type,
                loops:1,
                durationText:this.secToTime(e1.duration)
              }
      
    },
    
    onChange(evt){
      console.log("Change")
      this.adjustTimes();
    },
    
    adjustTimes(){
      var items= document.querySelectorAll('#mainList .card');
        for(var i=0;i<items.length;i++){
          this.playlist[i].time=this.secToTime(items[i].offsetTop*60);
         
        }
    },
    textChange(){
        console.log("TC",)
        this.adjustTimes()
    },
    mediaHeight (element){
      
      //return (element.duration*element.loops)+"px"
      return "120px"
    },
    
    checkMove (evt){
     // cant drag empty elements
      return (evt.draggedContext.element.title!=='');
    },
    
    
    sendMessage (btn) {
      this.$store.dispatch('sendMessage',{heading: this.heading,description: this.description})
      console.log(this.heading)
    },
    sendCommand (btn) {
      this.$store.dispatch('sendCommand',btn)
      console.log(btn)
    },
    onSignin () {
      console.log('email:', this.email)
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
    },
    onDismissed () {
      console.log('Dismissed alert')
      this.$store.dispatch('clearError')
    },
    secToTime (sec) {
      var secs=sec%60;
      var mins=((sec-secs)/60)%60;
      var hrs=(sec-mins*60-secs)/60/60;
      secs=Math.round(secs);
      if(secs<10)secs="0"+secs;
      if(mins<10)mins="0"+mins;
      return hrs+":"+mins+":"+secs;
    },
    timeToSec (time) {
       var times=time.split(":")
      var secs=parseInt(times[2],10)
      var mins=parseInt(times[1],10)
      var hrs=parseInt(times[0],10)
      
      return hrs*60*60+mins*60+secs;
    },
    clearPlaylist(){
      this.cleanList();
    },
    updatePlaylist(){
      var pList={duration:this.totalDuration,name:this.playlistName,color:this.color,type:"playlist"};
      pList.items=[];
      pList.id=this.loadedList.id;
      var item
      for(var i=0;i<this.playlist.length;i++){
        item=this.playlist[i]
        pList.items.push({index:i,duration:item.duration,loops:parseInt(item.loops,10),id:item.id})
      }
      console.log("Update",pList);
      this.$store.dispatch('updatePlaylistData', pList)

    },
    savePlaylist(){
      
      var pList={duration:this.totalDuration,name:this.playlistName,color:this.color,type:"playlist"};
      pList.items=[];
      var item
      for(var i=0;i<this.playlist.length;i++){
        item=this.playlist[i]
        pList.items.push({index:i,duration:item.duration,loops:parseInt(item.loops,10),id:item.id})
      }
      console.log("SAVE",pList);
      this.$store.dispatch('createPlaylist', pList)
    }
  }
}

</script>
<style scoped>
#mainList{
  padding-bottom: 150px;
}
.vue-swatches__trigger{
  width:20px!important;
  height:20px!important;
}
.buttonInput.input-group.input-group--solo {
    margin-left: 10px;
   
}
.buttonInput.input-group.input-group--solo label {
    top: 2px;
}
.buttonInput.input-group.input-group--solo {
    min-height: 26px; 
}
.buttonInput.input-group.input-group--solo .input-group__input{
  padding:0px 16px;
   width:80px;
}

</style>


// WEBPACK FOOTER //
// src/components/Content/Playlist.vue